import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';

import { InquiryList, InquiryDetail, InquiryDocuments } from '../features/inquiry';
import { InspectionList, InspectionDetail } from '../features/inspection';
import { NotificationList, NotificationDetail } from '../features/notification';
import { SignatureScreen, SignatureComplete } from '../features/signature';
import { PaymentMethod, PaymentComplete, PaymentConfirm, CashPaymentConfirm, PostpaidPaymentConfirm, CreditCardInput, PaymentPending, PaymentSuccess, PaymentFailure, PaymentFailed, ReceiptIssue } from '../features/payment';
import { SurveyScreen, SurveyComplete } from '../features/survey';
import { TermsOfService, PrivacyPolicy, Tokushoho } from '../features/legal';
import { useAccountIdCapture, useKeyboardVisible } from '../shared/hooks';
import AnimatedRoutes from './AnimatedRoutes';


const App: React.FC = () => {
  const keyboardVisible = useKeyboardVisible();

  // accountId はエントリ URL にしか含まれず SPA 遷移でクエリが消失するため、
  // どのルートで受け取っても sessionStorage に保存されるよう App ルートでキャプチャする
  // （後払い確認画面の email 初期値が入らないバグの再発防止）
  useAccountIdCapture();

  useEffect(() => {
    document.body.classList.toggle('keyboard-visible', keyboardVisible);
  }, [keyboardVisible]);

  return (
    <AnimatedRoutes>
    <Routes>
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/notifications" element={<NotificationList />} />
      <Route path="/notifications/:id" element={<NotificationDetail />} />
      <Route path="/inquiries" element={<InquiryList />} />
      <Route path="/inquiries/:id" element={<InquiryDetail />} />
      <Route path="/inquiries/:id/documents" element={<InquiryDocuments />} />
      <Route path="/inspections" element={<InspectionList />} />
      <Route path="/inspections/:id" element={<InspectionDetail />} />
      <Route path="/inspections/:id/sign" element={<SignatureScreen />} />
      <Route path="/inspections/:id/sign/complete" element={<SignatureComplete />} />
      <Route path="/inspections/:id/survey" element={<SurveyScreen />} />
      <Route path="/inspections/:id/survey/complete" element={<SurveyComplete />} />
      <Route path="/inquiries/:id/sign" element={<SignatureScreen />} />
      <Route path="/inquiries/:id/sign/complete" element={<SignatureComplete />} />
      <Route path="/inquiries/:id/payment-method" element={<PaymentMethod />} />
      <Route path="/inquiries/:id/cash-payment-confirm" element={<CashPaymentConfirm />} />
      <Route path="/inquiries/:id/postpaid-confirm" element={<PostpaidPaymentConfirm />} />
      <Route path="/inquiries/:id/credit-card" element={<CreditCardInput />} />
      <Route path="/inquiries/:id/payment-confirm" element={<PaymentConfirm />} />
      <Route path="/inquiries/:id/payment-pending" element={<PaymentPending />} />
      <Route path="/inquiries/:id/receipt" element={<ReceiptIssue />} />
      <Route path="/inquiries/:id/payment-complete" element={<PaymentComplete />} />
      <Route path="/inquiries/:id/payment-failed" element={<PaymentFailed />} />
      <Route path="/payment-complete" element={<PaymentComplete />} />
      <Route path="/payment-failed" element={<PaymentFailed />} />
      <Route path="/payment-pending" element={<PaymentPending />} />
      <Route path="/inquiries/:id/survey" element={<SurveyScreen />} />
      <Route path="/inquiries/:id/survey/complete" element={<SurveyComplete />} />
      <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/tokushoho" element={<Tokushoho />} />
      <Route path="/success" element={<PaymentSuccess />} />
      <Route path="/failed" element={<PaymentFailure />} />
      <Route path="/" element={<InquiryList />} />
    </Routes>
    </AnimatedRoutes>
  );
}

export default App;
